import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { AuthService } from "../auth/auth.service";
import { NextMethodsEnum } from "../enums/next-methods.enum";
import { HttpService } from "../http/http.service";
import { RetrieveSystemChangesForUsersReply, SystemChangesForUsers } from "./system-changes.model";

@Injectable({
    providedIn: 'root'
})
export class SystemChangesService {

    private systemChanges = new BehaviorSubject<SystemChangesForUsers[]>([]);
    private notify = new BehaviorSubject<boolean>(false);

    constructor(
        private authService: AuthService,
        private http: HttpService,
    ) {
    }

    get systemChanges$(): Observable<SystemChangesForUsers[]> {
        return this.systemChanges.asObservable();
    }

    get notify$(): Observable<boolean> {
        return this.notify.asObservable();
    }

    retrieveSystemChangesForUsers() {
        this.http.post<RetrieveSystemChangesForUsersReply>(NextMethodsEnum.retrieveSystemChangesForUsers, {}).subscribe(reply => {
            this.systemChanges.next(reply.systemChangesForUsers ?? []);
            this.notify.next(reply.showNotification);
        });
    }
}